import type { PropsWithChildren } from 'react';
import LogoComponent from 'components/layout/LogoComponent';
import { css } from '@emotion/css';
import { CenteredPage, CenteredPageProps } from './CenteredPage';

const logoStyle = css`
  padding: 0.5em;
`;

const LogoPage = ({ children, ...props }: PropsWithChildren<CenteredPageProps>) => (
  <div style={{ inset: 0, position: 'absolute' }}>
    <CenteredPage {...props}>
      <div className={logoStyle}>
        <LogoComponent />
      </div>
      <div>{children}</div>
    </CenteredPage>
  </div>
);

export default LogoPage;
